/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Step_3Inputs */

const en_svc_agents_step_3 = /** @type {(inputs: Svc_Agents_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build and test it against your real examples before it goes live.`)
};

const lv_svc_agents_step_3 = /** @type {(inputs: Svc_Agents_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzbūvējam un pārbaudām to ar Jūsu reālajiem piemēriem pirms ieviešanas.`)
};

/**
* | output |
* | --- |
* | "Build and test it against your real examples before it goes live." |
*
* @param {Svc_Agents_Step_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_step_3 = /** @type {((inputs?: Svc_Agents_Step_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Step_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_step_3(inputs)
	return en_svc_agents_step_3(inputs)
});